export default function noop(): void {
  // No-op
}
